import { Params } from '@angular/router';
import { RequestFilter } from '../../core/models/request-filter.model';

export interface FilterQueryParams extends Record<string, string | undefined> {
  status?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}

export class RequestFilterMapper {
  static toQueryParams(filters: {
    statusFilter: string | null;
    fromDateFilter: string | null;
    toDateFilter: string | null;
    searchTerm?: string;
  }): FilterQueryParams {
    const params: FilterQueryParams = {};

    const trimmedStatus = filters.statusFilter?.trim();
    if (trimmedStatus) {
      params.status = trimmedStatus;
    }

    if (filters.fromDateFilter) {
      params.fromDate = filters.fromDateFilter;
    }

    if (filters.toDateFilter) {
      params.toDate = filters.toDateFilter;
    }

    const trimmedSearch = filters.searchTerm?.trim();
    if (trimmedSearch) {
      params.search = trimmedSearch;
    }

    return params;
  }

  static fromQueryParams(queryParams: Params): {
    statusFilter: string | null;
    fromDateFilter: string | null;
    toDateFilter: string | null;
    searchTerm: string;
  } {
    return {
      statusFilter: queryParams['status'] ?? '',
      fromDateFilter: queryParams['fromDate'] ?? null,
      toDateFilter: queryParams['toDate'] ?? null,
      searchTerm: queryParams['search'] ?? '',
    };
  }

  static toRequestFilter(filters: {
    statusFilter: string | null;
    fromDateFilter: string | null;
    toDateFilter: string | null;
    searchTerm?: string;
  }): Partial<RequestFilter> {
    return {
      status: filters.statusFilter ?? undefined,
      fromDate: filters.fromDateFilter ?? undefined,
      toDate: filters.toDateFilter ?? undefined,
      search: filters.searchTerm?.trim() ?? undefined,
    };
  }
}
